import React from "react";
import CSSTransition from "react-transition-group/CSSTransition";

import "../styles/modal.css";

const animationTiming = {
  enter: 400,
  exit: 1000
};

const modal = props => {
  return (
    <CSSTransition
      mountOnEnter
      unmountOnExit
      in={props.show}
      timeout={animationTiming}
      classNames={{
        enter: "",
        enterActive: "ModalOpen",
        exit: "",
        exitActive: "ModalClosed"
      }}
    >
      <div className="Modal">
        {props.options != null ? <h1>{props.options.titleModal}</h1> : null}
        {props.options != null ? <p>{props.options.messageModal}</p> : null}
        <button className="btn" onClick={props.closed}>
          Dismiss
        </button>
      </div>
    </CSSTransition>
  );
};

export default modal;



// WEBPACK FOOTER //
// ./src/components/modal.js